
import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ActivatedRoute, Params } from '@angular/router'

@Component({
    template: ` <router-outlet></router-outlet>`,
    styleUrls: ['./ESOA-form.component.scss']

})

export class ESOAFormComponent implements OnInit {
    uniqueLink: string
    constructor(private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.getParams();
        if (this.uniqueLink !== undefined && this.uniqueLink !== '') {
            this.router.navigateByUrl('/viewsoaemailform/' + this.uniqueLink)
        }
    }


    getParams() {
        this.route.params.forEach((params: Params) => {
            this.uniqueLink = this.route.snapshot.params["{accessCode}"]
        })
    }
}